import React from "react";
import CreateCoursePhases from "../../Components/layouts/createcourse/CreateCoursePhases";
import { CreateProvider } from "../../Context/CreateContext";

const CreateCourseLayout = () => {
    return (
        <div className="CreateCourseLayout p-[15px] bg-[#FBF7FF] rounded-[10px] m-[20px]">
            <CreateProvider>
                <CreateCoursePhases />
            </CreateProvider>
        </div>
    );
};

export default CreateCourseLayout;
